import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchAddressesOptionQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.BuildingsFilters>;
  pagination?: Types.InputMaybe<Types.BuildingsConnectionArgs>;
}>;


export type FetchAddressesOptionQuery = { __typename?: 'Query', buildings: { __typename?: 'BuildingsBuildingConnection', edges: Array<{ __typename?: 'BuildingsBuildingEdge', node: { __typename?: 'Building', id: string, name?: string | null, hasIot: boolean, location: { __typename?: 'Location', streetAddress: string, zipcode: string, city: { __typename?: 'City', name: string } }, devices: Array<{ __typename?: 'Door', id: string } | { __typename?: 'Elevator', id: string } | { __typename?: 'Escalator', id: string } | { __typename?: 'FireAlarm', id: string } | { __typename?: 'Hvac', id: string }> } }>, pageInfo: { __typename?: 'BuildingsPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type FetchSelectedAddressesOptionQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.BuildingsFilters>;
}>;


export type FetchSelectedAddressesOptionQuery = { __typename?: 'Query', buildings: { __typename?: 'BuildingsBuildingConnection', edges: Array<{ __typename?: 'BuildingsBuildingEdge', node: { __typename?: 'Building', id: string, name?: string | null, hasIot: boolean, location: { __typename?: 'Location', streetAddress: string, zipcode: string, city: { __typename?: 'City', name: string } }, devices: Array<{ __typename?: 'Door', id: string } | { __typename?: 'Elevator', id: string } | { __typename?: 'Escalator', id: string } | { __typename?: 'FireAlarm', id: string } | { __typename?: 'Hvac', id: string }> } }> } };

export type AddressOptionFragment = { __typename?: 'Building', id: string, name?: string | null, hasIot: boolean, location: { __typename?: 'Location', streetAddress: string, zipcode: string, city: { __typename?: 'City', name: string } }, devices: Array<{ __typename?: 'Door', id: string } | { __typename?: 'Elevator', id: string } | { __typename?: 'Escalator', id: string } | { __typename?: 'FireAlarm', id: string } | { __typename?: 'Hvac', id: string }> };

export const AddressOptionFragmentDoc = gql`
    fragment AddressOption on Building {
  id
  name
  hasIot
  location {
    streetAddress
    zipcode
    city {
      name
    }
  }
  devices {
    id
  }
}
    `;
export const FetchAddressesOptionDocument = gql`
    query FetchAddressesOption($filters: BuildingsFilters, $pagination: BuildingsConnectionArgs) {
  buildings(filters: $filters, pagination: $pagination) {
    edges {
      node {
        ...AddressOption
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${AddressOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchAddressesOptionGQL extends Apollo.Query<FetchAddressesOptionQuery, FetchAddressesOptionQueryVariables> {
    override document = FetchAddressesOptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchSelectedAddressesOptionDocument = gql`
    query FetchSelectedAddressesOption($filters: BuildingsFilters) {
  buildings(filters: $filters) {
    edges {
      node {
        ...AddressOption
      }
    }
  }
}
    ${AddressOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchSelectedAddressesOptionGQL extends Apollo.Query<FetchSelectedAddressesOptionQuery, FetchSelectedAddressesOptionQueryVariables> {
    override document = FetchSelectedAddressesOptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }